var _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTenX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 840,
    height: 840,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            :root {\n                --bg: #38bdf8;\n                --fg: #6366f1;\n                --inter: #075985;\n            }\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "BrowserWithCodeIconClipPath-"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    transform: "translate(-2 -2)",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm.53 5.47a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.72-1.72v5.69a.75.75 0 001.5 0v-5.69l1.72 1.72a.75.75 0 101.06-1.06l-3-3z",
    clipRule: "evenodd"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "var(--bg)",
    transform: "translate(-2, -2)",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm.53 5.47a.75.75 0 00-1.06 0l-3 3a.75.75 0 101.06 1.06l1.72-1.72v5.69a.75.75 0 001.5 0v-5.69l1.72 1.72a.75.75 0 101.06-1.06l-3-3z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 2,
    stroke: "var(--fg)",
    transform: "translate(8, 7) scale(0.7)",
    d: "M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#BrowserWithCodeIconClipPath-)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    strokeWidth: 2,
    stroke: "var(--inter)",
    transform: "translate(8, 7) scale(0.7)",
    d: "M15 11.25l-3-3m0 0l-3 3m3-3v7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenX);
export default __webpack_public_path__ + "static/media/ten-x.10a2ea8502b8717d4c8784262e5aada5.svg";
export { ForwardRef as ReactComponent };